export default "__VITE_ASSET__5b6febeb__"